<script setup lang="ts">
defineProps({
  icon: { type: String, default: '' },
  mobile: { type: Boolean, default: false },
  name: { type: String, default: 'name' },
  route: { type: String, default: '/' },
  collapse: { type: Boolean, default: false },
  exact: { type: Boolean, default: false },
  className: { type: String, default: 'sidebar-item' },
  style: {
    type: Object,
    default: function () {
      return {};
    },
  },
});
</script>

<template>
  <RouterLink
    :id="name.toLowerCase() + '_nav'"
    v-tooltip.right="{ value: name, disabled: !collapse }"
    :to="route"
    :active-class="exact ? '' : undefined"
    :class="[className, { collapsed: collapse }, { mobile: mobile }]"
    class="no-underline"
  >
    <span class="material-icons" v-text="icon" />
    <p :data-page-title="name">{{ name }}</p>
  </RouterLink>
</template>

<style scoped lang="scss">
.sidebar-item:first-of-type {
  margin-top: 0;
}
.sidebar-item,
.admin-sidebar-item {
  margin-bottom: 0.5rem;

  text-decoration: none;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem;
  position: relative;
  border-radius: 2rem;
  transition: 0.2s ease;
  p {
    margin-left: 0.5rem;
    height: 1rem;
    color: $grayDark;
    font-size: 0.875rem;
    &::after {
      content: attr(data-page-title);
      height: 0;
      visibility: hidden;
      overflow: hidden;
      user-select: none;
      pointer-events: none;
      font-weight: bold;
      @media speech {
        display: none;
      }
    }
  }
  .material-icons {
    color: var(--primary-color-medium);
    font-size: 1rem;
  }

  &:hover {
    background: rgba(var(--primary-color-light), 0.25);
  }

  &.router-link-exact-active,
  &.router-link-active {
    background-color: var(--primary-color-extra-light);
    p {
      color: var(--primary-color-dark);
      font-weight: bold;
    }
    .material-icons {
      color: var(--primary-color-dark);
    }
  }
  &.collapsed {
    p {
      display: none;
    }
  }
  &:not(.mobile) {
    @media (max-width: 768px) {
      p {
        display: none;
      }
    }
  }
}
</style>
